export const ScrollToTop = () => {
    setTimeout(() => {
        window.scrollTo({top: 200, behavior: 'smooth'});
    }, 100);
};